import { BemVindoModule } from './bem-vindo/bem-vindo.module';
import { AcessoModule } from './acesso';
import { AcessoExternoModule } from './acesso-externo';
import { VisualizadorModule} from './visualizador';
import { SessaoExpiradaModule } from './sessao-expirada';
import { AcessoGovBrBronzeModule } from './acesso-gov-br-bronze/acesso-gov-br-bronze.module';

export const FEATURES = [
    BemVindoModule,
    AcessoModule,
    AcessoGovBrBronzeModule,
    VisualizadorModule,
    AcessoExternoModule,
    SessaoExpiradaModule
];
